import { SvgIconType } from './svg.interface';

const LinkIcon: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#0570DE'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.42177 9.57764C1.68315 8.8388 1.68315 7.64091 2.42177 6.90207L3.30108 6.02251C3.59256 5.73094 3.59256 5.25821 3.30108 4.96664C3.00959 4.67506 2.53699 4.67506 2.2455 4.96664L1.3662 5.84619C0.0445996 7.16817 0.0445992 9.31153 1.3662 10.6335C2.6878 11.9555 4.83054 11.9555 6.15215 10.6335L7.03145 9.75396C7.32294 9.46239 7.32294 8.98965 7.03145 8.69808C6.73996 8.40651 6.26736 8.40651 5.97588 8.69808L5.09657 9.57764C4.35795 10.3165 3.1604 10.3165 2.42177 9.57764Z"
      fill={color}
    />
    <path
      d="M9.57823 5.09793C10.3169 4.35909 10.3169 3.1612 9.57823 2.42236C8.8396 1.68352 7.64205 1.68352 6.90343 2.42236L6.02412 3.30192C5.73264 3.59349 5.26004 3.59349 4.96855 3.30192C4.67706 3.01035 4.67706 2.53761 4.96855 2.24604L5.84785 1.36649C7.16946 0.0445041 9.3122 0.0445047 10.6338 1.36649C11.9554 2.68847 11.9554 4.83183 10.6338 6.15381L9.7545 7.03336C9.46301 7.32494 8.99041 7.32494 8.69892 7.03336C8.40744 6.74179 8.40744 6.26906 8.69892 5.97749L9.57823 5.09793Z"
      fill={color}
    />
    <path
      d="M3.97943 8.08524C3.68794 7.79367 3.68794 7.32094 3.97943 7.02937L7.14615 3.86174C7.43764 3.57017 7.91023 3.57017 8.20172 3.86174C8.49321 4.15331 8.49321 4.62604 8.20172 4.91762L5.035 8.08524C4.74351 8.37682 4.27092 8.37682 3.97943 8.08524Z"
      fill={color}
    />
  </svg>
);

export default LinkIcon;
